import diaAvatar from '../images/dia-profile-picture.jpeg';
import preetiAvatar from '../images/preeti3.png';
import kunalAvatar from '../images/Kunal.png';
import radhikaAvatar from '../images/Radhika.png';
import diaPost1 from '../images/dia1.png';
import diaPost2 from '../images/dia2.png';
import diaPost3 from '../images/dia3.png';
import preetiPost1 from '../images/preeti1.png';
import preetiPost2 from '../images/preeti2.png';
import preetiPost3 from '../images/preeti3.png';
import reelsposter1 from '../images/reelsposter1.png';
import matar from '../images/matar.png';
import shayari from '../images/shayari.png';
import swiggy from '../images/swiggy.png';
import baniya from '../images/baniya.png';
import autopay from '../images/autopay.png';
import demat from '../images/demat.png';
import naukri from '../images/naukri.png';
import dog from '../images/dog.png';
import wfhjobs from '../images/wfhjobs.png';
import delivery from '../videos/delivery.mp4';
import radhikavid from '../videos/radhika.mp4';
export const FEED_POSTS = [
    {
        id: 'rahul-video-1',
        profile: {
            name: 'Rahul',
            avatar: diaAvatar,
            verified: true,
        },
        media: {
            type: 'video',
            src: delivery
        },
        caption: 'Delivery Driver bane aur 30 hazaar mahine ka kamaye',
        likes: 182,
        timestamp: '1h ago',
        showChatBtn: true,
    },
    {
        id: 'wfhjobs-post-1',
        profile: {
            name: 'Kunal',
            avatar: kunalAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: wfhjobs,
            alt: 'WFH jobs collage',
        },
        caption: 'Jaao 5 naukri jisse 30 hazaar per mahina kamao ',
        likes: 12228,
        timestamp: '18h ago',
        showChatBtn: true,
    },
    {
        id: 'baniya-post-1',
        profile: {
            name: 'Prakash',
            avatar: preetiAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: baniya,
            alt: 'Baniya store success tips',
        },
        caption: 'Meesho se apna business 2 guna kare',
        likes: 1298,
        timestamp: '6d ago',
        showChatBtn: true,
    },
    {
        id: 'matar-post-1',
        profile: {
            name: 'Mohan',
            avatar: diaAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: matar,
            alt: 'Business ideas around matar',
        },
        caption: 'Matar se business se laakho kamaye',
        likes: 121,
        timestamp: '2h ago',
        showChatBtn: true,
    },
    {
        id: 'radhika-video-1',
        profile: {
            name: 'Radhika',
            avatar: radhikaAvatar,
            verified: true,
        },
        media: {
            type: 'video',
            src: radhikavid,
        },
        caption: 'Work From Home Job paaye aur jeevan safal bnaae',
        likes: 1882,
        timestamp: '8h ago',
        showChatBtn: false,
    },
    {
        id: 'swiggy-post-1',
        profile: {
            name: 'Rahul',
            avatar: diaAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: swiggy,
            alt: 'Swiggy delivery partner earnings',
        },
        caption: 'Mahina ka 30 hazaar kamao Swiggy me Delivery boy lag ke',
        likes: 1221,
        timestamp: '22h ago',
        showChatBtn: true,
    },
    {
        id: 'autopay-post-1',
        profile: {
            name: 'Arjun',
            avatar: diaAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: autopay,
            alt: 'Mobile screen showing autopay toggle',
        },
        caption: 'Autopay band karna seekhe apne jald se',
        likes: 12928,
        timestamp: '6h ago',
        showChatBtn: true,
    },
    {
        id: 'demat-post-1',
        profile: {
            name: 'Amit',
            avatar: diaAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: demat,
            alt: 'Demat account tips',
        },
        caption: 'Demat account khole aur apna paisa 10 guna kare',
        likes: 1228,
        timestamp: '16h ago',
        showChatBtn: true,
    },
    {
        id: 'naukri-post-1',
        profile: {
            name: 'Vikram',
            avatar: diaAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: naukri,
            alt: 'City skyline with job dreams',
        },
        caption: 'Bade seher me naukri paane ka sapna hoga pura',
        likes: 12228,
        timestamp: '18h ago',
        showChatBtn: true,
    },
    {
        id: 'dog-post-1',
        profile: {
            name: 'Ramesh',
            avatar: diaAvatar,
            verified: true,
        },
        media: {
            type: 'image',
            src: dog,
            alt: 'Dog walking hustle inspiration',
        },
        caption: 'Jaao 5 naukri jisse 30 hazaar per mahina kamao ',
        likes: 12228,
        timestamp: '18h ago',
        showChatBtn: true,
    },
];
export default FEED_POSTS;










